import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';

import authReducer from '~/thunks/auth/authSlice';
import categoryReducer from '~/thunks/category/categorySlice';
import fileReducer from '~/thunks/file/fileSlice';
import inventoryReducer from '~/thunks/inventory/inventorySlice';
import packageReducer from '~/thunks/package/packageSlice';
import quoteReducer from '~/thunks/quote/quoteSlice';
import userReducer from '~/thunks/user/userSlice';
import activityReducer from '~/thunks/activity/activitySlice';
import clientReducer from '~/thunks/client/clientSlice';
import masterDataReducer from '~/thunks/masterData/masterDataSlice';
import orderReducer from '~/thunks/order/orderSlice';
import scheduleReducer from '~/thunks/schedule/scheduleSlice';
import jobReducer from '~/thunks/job/jobSlice';
import truckReducer from '~/thunks/truck/truckSlice';
import trailerReducer from '~/thunks/trailer/trailerSlice';
import equipmentReducer from '~/thunks/equipment/equipmentSlice';
import variantReducer from '~/thunks/variant/variantSlice';
import vendorReducer from '~/thunks/vendors/vendorsSlice';
import appointmentReducer from '~/thunks/appointment/appointmentSlice';
import taskReducer from '~/thunks/task/taskSlice';
import couponReducer from '~/thunks/coupon/couponSlice';
import purchaseOrderReducer from '~/thunks/purchaseOrder/purchaseOrderSlice';
import checklistReducer from '~/thunks/checklist/checklistSlice';
import quarantineReducer from '~/thunks/quarantine/quarantineSlice';
import incidentReducer from '~/thunks/incident/incidentThunk';
import invoiceReducer from '~/thunks/invoice/invoiceSlice';
import reportsReducer from '~/thunks/reports/reportsSlice';
import roleReducer from '~/thunks/role/roleSlice';
import noteReducer from '~/thunks/note/noteThunk';
import statisticReducer from '~/thunks/statistic/statisticSlice';
import goalReducer from '~/thunks/goal/goalSlice';
import globalReducer from '~/thunks/global/globalSlice';
import venueReducer from '~/thunks/venue/venueSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  quote: quoteReducer,
  inventory: inventoryReducer,
  package: packageReducer,
  category: categoryReducer,
  file: fileReducer,
  activity: activityReducer,
  client: clientReducer,
  masterData: masterDataReducer,
  schedule: scheduleReducer,
  order: orderReducer,
  job: jobReducer,
  truck: truckReducer,
  trailer: trailerReducer,
  equipment: equipmentReducer,
  variant: variantReducer,
  vendor: vendorReducer,
  appointment: appointmentReducer,
  task: taskReducer,
  coupon: couponReducer,
  purchaseOrder: purchaseOrderReducer,
  checklist: checklistReducer,
  incident: incidentReducer,
  quarantine: quarantineReducer,
  invoice: invoiceReducer,
  reports: reportsReducer,
  role: roleReducer,
  note: noteReducer,
  statistic: statisticReducer,
  goal: goalReducer,
  global: globalReducer,
  venue: venueReducer,
});

export function makeStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
    devTools: process.env.NODE_ENV !== 'production',
  });
}

const store = makeStore();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export default store;
